/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_InteractionApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_InteractionApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class InteractionApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_InteractionApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_InteractionApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    /**
     * Get all available assistants.
     * @return Success
     */
    getAssistants(cancelToken?: CancelToken): AxiosPromise<GetAssistantsResponse> {
        let url_ = "/api/assist-interaction-service/v1/assistants";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetAssistantsResponse>(options_);
    }

    /**
     * Get assistant details
     * @return Success
     */
    assistants(assistantId: string, cancelToken?: CancelToken): AxiosPromise<GetAssistantResponse> {
        let url_ = "/api/assist-interaction-service/v1/assistants/{assistantId}";
        if (assistantId === undefined || assistantId === null)
            throw new Error("The parameter 'assistantId' must be defined.");
        url_ = url_.replace("{assistantId}", encodeURIComponent("" + assistantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetAssistantResponse>(options_);
    }

    /**
     * Create a new interaction.
     * @body (optional) The interaction creation request.
     * @return Success
     */
    createInteraction(body: CreateInteractionRequest | undefined, cancelToken?: CancelToken): AxiosPromise<Interaction> {
        let url_ = "/api/assist-interaction-service/v1/interactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<Interaction>(options_);
    }

    /**
     * Get all interactions for the current tenant.
     * @return Success
     */
    getInteractions(cancelToken?: CancelToken): AxiosPromise<GetInteractionsResponse> {
        let url_ = "/api/assist-interaction-service/v1/interactions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetInteractionsResponse>(options_);
    }

    /**
     * Get a specific interaction by its ID.
     * @interactionId The interaction ID.
     * @return Success
     */
    getInteraction(interactionId: string, cancelToken?: CancelToken): AxiosPromise<Interaction> {
        let url_ = "/api/assist-interaction-service/v1/interactions/{interactionId}";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<Interaction>(options_);
    }

    /**
     * Create a new message for a specific interaction.
     * @interactionId The interaction ID to create the message for.
     * @body (optional) The message creation request.
     * @return Success
     */
    createMessage(interactionId: string, body: CreateMessageRequest | undefined, cancelToken?: CancelToken): AxiosPromise<Message> {
        let url_ = "/api/assist-interaction-service/v1/messages/{interactionId}";
        if (interactionId === undefined || interactionId === null)
            throw new Error("The parameter 'interactionId' must be defined.");
        url_ = url_.replace("{interactionId}", encodeURIComponent("" + interactionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<Message>(options_);
    }

    /**
     * Get messages with optional filtering.
     * @targetRoleId (optional) Filter by target Role ID.
     * @interactionIds (optional) Filter by interaction IDs.
     * @status (optional) Filter by message status.
     * @since (optional) Filter messages since this date.
     * @type (optional) Filter by message type.
     * @offset (optional) Number of messages to skip.
     * @limit (optional) Maximum number of messages to return.
     * @return Success
     */
    getMessages(targetRoleId: string | undefined, interactionIds: string[] | undefined, status: MessageStatus | undefined, since: Date | undefined, type: MessageTypeFilter | undefined, offset: number | undefined, limit: number | undefined, cancelToken?: CancelToken): AxiosPromise<GetMessagesResponse> {
        let url_ = "/api/assist-interaction-service/v1/messages?";
        if (targetRoleId === null)
            throw new Error("The parameter 'targetRoleId' cannot be null.");
        else if (targetRoleId !== undefined)
            url_ += "targetRoleId=" + encodeURIComponent("" + targetRoleId) + "&";
        if (interactionIds === null)
            throw new Error("The parameter 'interactionIds' cannot be null.");
        else if (interactionIds !== undefined)
            interactionIds && interactionIds.forEach(item => { url_ += "interactionIds=" + encodeURIComponent("" + item) + "&"; });
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (since === null)
            throw new Error("The parameter 'since' cannot be null.");
        else if (since !== undefined)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toJSON() : "") + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetMessagesResponse>(options_);
    }

    /**
     * Get notification messages for a user.
     * @targetRoleId (optional) The target role ID of a user to get notifications for.
     * @status (optional) Filter by message status.
     * @since (optional) Filter notifications since this date.
     * @offset (optional) Number of notifications to skip.
     * @limit (optional) Maximum number of notifications to return.
     * @interactionIds (optional) Optional filter by interaction IDs.
     * @return Success
     */
    getNotifications(targetRoleId: string | undefined, status: MessageStatus | undefined, since: Date | undefined, offset: number | undefined, limit: number | undefined, interactionIds: string[] | undefined, cancelToken?: CancelToken): AxiosPromise<GetMessagesResponse> {
        let url_ = "/api/assist-interaction-service/v1/messages/notifications?";
        if (targetRoleId === null)
            throw new Error("The parameter 'targetRoleId' cannot be null.");
        else if (targetRoleId !== undefined)
            url_ += "targetRoleId=" + encodeURIComponent("" + targetRoleId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (since === null)
            throw new Error("The parameter 'since' cannot be null.");
        else if (since !== undefined)
            url_ += "since=" + encodeURIComponent(since ? "" + since.toJSON() : "") + "&";
        if (offset === null)
            throw new Error("The parameter 'offset' cannot be null.");
        else if (offset !== undefined)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (interactionIds === null)
            throw new Error("The parameter 'interactionIds' cannot be null.");
        else if (interactionIds !== undefined)
            interactionIds && interactionIds.forEach(item => { url_ += "interactionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<GetMessagesResponse>(options_);
    }

    /**
     * Mark a message as read.
     * @messageId The message ID to mark as read.
     * @return Success
     */
    markAsRead(messageId: string, cancelToken?: CancelToken): AxiosPromise<MarkAsReadResponse> {
        let url_ = "/api/assist-interaction-service/v1/messages/{messageId}/mark_as_read";
        if (messageId === undefined || messageId === null)
            throw new Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<MarkAsReadResponse>(options_);
    }

    /**
     * Authenticate client and return access token
     * @body (optional) 
     * @return Success
     */
    token(body: AuthenticationRequest | undefined, cancelToken?: CancelToken): AxiosPromise<void> {
        let url_ = "/api/assist-interaction-service/auth/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            data: content_,
            url: url_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.opts.axios.request<void>(options_);
    }
}

export enum ActionType {
    Primary = "Primary",
    Secondary = "Secondary",
    Danger = "Danger",
    Link = "Link",
}

export enum AssistantStatus {
    Not_Yet_Connected = "Not_Yet_Connected",
    Online = "Online",
    Disconnected = "Disconnected",
}

export class AuthenticationRequest implements IAuthenticationRequest {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IAuthenticationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): AuthenticationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IAuthenticationRequest {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class CreateInteractionRequest implements ICreateInteractionRequest {
    createdBy!: CreatedBy;
    assistantId!: string | undefined;

    constructor(data?: ICreateInteractionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.createdBy = new CreatedBy();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"] ? CreatedBy.fromJS(_data["createdBy"]) : new CreatedBy();
            this.assistantId = _data["assistantId"];
        }
    }

    static fromJS(data: any): CreateInteractionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInteractionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["assistantId"] = this.assistantId;
        return data;
    }
}

export interface ICreateInteractionRequest {
    createdBy: CreatedBy;
    assistantId: string | undefined;
}

export class CreateMessageRequest implements ICreateMessageRequest {
    createdBy!: CreatedBy;
    assistantId!: string | undefined;
    targetRoleId!: string;
    type!: MessageType;
    details!: SimpleMessage;
    suggestions!: string[] | undefined;
    context!: { [key: string]: any; } | undefined;
    additionalContext!: { [key: string]: any; } | undefined;

    constructor(data?: ICreateMessageRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.createdBy = new CreatedBy();
            this.details = new SimpleMessage();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdBy = _data["createdBy"] ? CreatedBy.fromJS(_data["createdBy"]) : new CreatedBy();
            this.assistantId = _data["assistantId"];
            this.targetRoleId = _data["targetRoleId"];
            this.type = _data["type"];
            this.details = _data["details"] ? SimpleMessage.fromJS(_data["details"]) : new SimpleMessage();
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(item);
            }
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (this.context as any)![key] = _data["context"][key];
                }
            }
            if (_data["additionalContext"]) {
                this.additionalContext = {} as any;
                for (let key in _data["additionalContext"]) {
                    if (_data["additionalContext"].hasOwnProperty(key))
                        (this.additionalContext as any)![key] = _data["additionalContext"][key];
                }
            }
        }
    }

    static fromJS(data: any): CreateMessageRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["assistantId"] = this.assistantId;
        data["targetRoleId"] = this.targetRoleId;
        data["type"] = this.type;
        data["details"] = this.details ? this.details.toJSON() : undefined as any;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item);
        }
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (data["context"] as any)[key] = (this.context as any)[key];
            }
        }
        if (this.additionalContext) {
            data["additionalContext"] = {};
            for (let key in this.additionalContext) {
                if (this.additionalContext.hasOwnProperty(key))
                    (data["additionalContext"] as any)[key] = (this.additionalContext as any)[key];
            }
        }
        return data;
    }
}

export interface ICreateMessageRequest {
    createdBy: CreatedBy;
    assistantId: string | undefined;
    targetRoleId: string;
    type: MessageType;
    details: SimpleMessage;
    suggestions: string[] | undefined;
    context: { [key: string]: any; } | undefined;
    additionalContext: { [key: string]: any; } | undefined;
}

export class CreatedBy implements ICreatedBy {
    type!: CreatedByType;
    id!: string | undefined;

    constructor(data?: ICreatedBy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreatedBy {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreatedBy {
    type: CreatedByType;
    id: string | undefined;
}

export enum CreatedByType {
    User = "User",
    Assistant = "Assistant",
    System = "System",
}

export class GetAssistantResponse implements IGetAssistantResponse {
    id!: string | undefined;
    description!: string | undefined;
    status!: AssistantStatus;
    lastSeen!: Date;

    constructor(data?: IGetAssistantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.status = _data["status"];
            this.lastSeen = _data["lastSeen"] ? new Date(_data["lastSeen"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GetAssistantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssistantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["status"] = this.status;
        data["lastSeen"] = this.lastSeen ? this.lastSeen.toISOString() : undefined as any;
        return data;
    }
}

export interface IGetAssistantResponse {
    id: string | undefined;
    description: string | undefined;
    status: AssistantStatus;
    lastSeen: Date;
}

export class GetAssistantsResponse implements IGetAssistantsResponse {
    assistants!: { [key: string]: GetAssistantResponse; } | undefined;

    constructor(data?: IGetAssistantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["assistants"]) {
                this.assistants = {} as any;
                for (let key in _data["assistants"]) {
                    if (_data["assistants"].hasOwnProperty(key))
                        (this.assistants as any)![key] = _data["assistants"][key] ? GetAssistantResponse.fromJS(_data["assistants"][key]) : new GetAssistantResponse();
                }
            }
        }
    }

    static fromJS(data: any): GetAssistantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAssistantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.assistants) {
            data["assistants"] = {};
            for (let key in this.assistants) {
                if (this.assistants.hasOwnProperty(key))
                    (data["assistants"] as any)[key] = this.assistants[key] ? this.assistants[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IGetAssistantsResponse {
    assistants: { [key: string]: GetAssistantResponse; } | undefined;
}

export class GetInteractionsResponse implements IGetInteractionsResponse {
    interactions!: Interaction[] | undefined;

    constructor(data?: IGetInteractionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["interactions"])) {
                this.interactions = [] as any;
                for (let item of _data["interactions"])
                    this.interactions!.push(Interaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInteractionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInteractionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.interactions)) {
            data["interactions"] = [];
            for (let item of this.interactions)
                data["interactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetInteractionsResponse {
    interactions: Interaction[] | undefined;
}

export class GetMessagesResponse implements IGetMessagesResponse {
    messages!: Message[] | undefined;

    constructor(data?: IGetMessagesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(Message.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMessagesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMessagesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetMessagesResponse {
    messages: Message[] | undefined;
}

export class Interaction implements IInteraction {
    id!: string | undefined;
    createdBy!: CreatedBy;
    assistantId!: string | undefined;
    createdAt!: Date;
    updatedAt!: Date;

    constructor(data?: IInteraction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdBy = _data["createdBy"] ? CreatedBy.fromJS(_data["createdBy"]) : undefined as any;
            this.assistantId = _data["assistantId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): Interaction {
        data = typeof data === 'object' ? data : {};
        let result = new Interaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["assistantId"] = this.assistantId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IInteraction {
    id: string | undefined;
    createdBy: CreatedBy;
    assistantId: string | undefined;
    createdAt: Date;
    updatedAt: Date;
}

export class MarkAsReadResponse implements IMarkAsReadResponse {
    success!: boolean;
    messageId!: string | undefined;

    constructor(data?: IMarkAsReadResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.messageId = _data["messageId"];
        }
    }

    static fromJS(data: any): MarkAsReadResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAsReadResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["messageId"] = this.messageId;
        return data;
    }
}

export interface IMarkAsReadResponse {
    success: boolean;
    messageId: string | undefined;
}

export class Message implements IMessage {
    id!: string | undefined;
    type!: MessageType;
    interactionId!: string | undefined;
    createdBy!: CreatedBy;
    targetRoleId!: string | undefined;
    createdAt!: Date;
    updatedAt!: Date;
    details!: SimpleMessage | undefined;
    suggestions!: string[] | undefined;
    context!: { [key: string]: any; } | undefined;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.interactionId = _data["interactionId"];
            this.createdBy = _data["createdBy"] ? CreatedBy.fromJS(_data["createdBy"]) : undefined as any;
            this.targetRoleId = _data["targetRoleId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.details = _data["details"] ? SimpleMessage.fromJS(_data["details"]) : undefined as any;
            if (Array.isArray(_data["suggestions"])) {
                this.suggestions = [] as any;
                for (let item of _data["suggestions"])
                    this.suggestions!.push(item);
            }
            if (_data["context"]) {
                this.context = {} as any;
                for (let key in _data["context"]) {
                    if (_data["context"].hasOwnProperty(key))
                        (this.context as any)![key] = _data["context"][key];
                }
            }
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["interactionId"] = this.interactionId;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["targetRoleId"] = this.targetRoleId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["details"] = this.details ? this.details.toJSON() : undefined as any;
        if (Array.isArray(this.suggestions)) {
            data["suggestions"] = [];
            for (let item of this.suggestions)
                data["suggestions"].push(item);
        }
        if (this.context) {
            data["context"] = {};
            for (let key in this.context) {
                if (this.context.hasOwnProperty(key))
                    (data["context"] as any)[key] = (this.context as any)[key];
            }
        }
        return data;
    }
}

export interface IMessage {
    id: string | undefined;
    type: MessageType;
    interactionId: string | undefined;
    createdBy: CreatedBy;
    targetRoleId: string | undefined;
    createdAt: Date;
    updatedAt: Date;
    details: SimpleMessage | undefined;
    suggestions: string[] | undefined;
    context: { [key: string]: any; } | undefined;
}

export class MessageDetails implements IMessageDetails {

    protected _discriminator: string;

    constructor(data?: IMessageDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        this._discriminator = "MessageDetails";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): MessageDetails {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "SimpleMessage") {
            let result = new SimpleMessage();
            result.init(data);
            return result;
        }
        if (data["$type"] === "Notification") {
            let result = new Notification();
            result.init(data);
            return result;
        }
        if (data["$type"] === "Recommendation") {
            let result = new Recommendation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "UserAction") {
            let result = new UserAction();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SystemMessage") {
            let result = new SystemMessage();
            result.init(data);
            return result;
        }
        let result = new MessageDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }
}

export interface IMessageDetails {
}

export enum MessageStatus {
    Active = "Active",
    All = "All",
}

export enum MessageType {
    SimpleMessage = "SimpleMessage",
    Notification = "Notification",
    Recommendation = "Recommendation",
    UserAction = "UserAction",
    SystemMessage = "SystemMessage",
}

export enum MessageTypeFilter {
    SimpleMessage = "SimpleMessage",
    Notification = "Notification",
    Recommendation = "Recommendation",
    UserAction = "UserAction",
    SystemMessage = "SystemMessage",
    All = "All",
}

export class Notification extends MessageDetails implements INotification {
    type!: NotificationType;
    name!: string | undefined;
    text!: string | undefined;
    status!: NotificationStatus;
    priority!: Priority;
    actions!: QuickAction[] | undefined;

    constructor(data?: INotification) {
        super(data);
        this._discriminator = "Notification";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.text = _data["text"];
            this.status = _data["status"];
            this.priority = _data["priority"];
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(QuickAction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Notification {
        data = typeof data === 'object' ? data : {};
        let result = new Notification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["text"] = this.text;
        data["status"] = this.status;
        data["priority"] = this.priority;
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotification extends IMessageDetails {
    type: NotificationType;
    name: string | undefined;
    text: string | undefined;
    status: NotificationStatus;
    priority: Priority;
    actions: QuickAction[] | undefined;
}

export enum NotificationStatus {
    Unread = "Unread",
    Read = "Read",
}

export enum NotificationType {
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
    Success = "Success",
}

export enum Priority {
    Low = "Low",
    Medium = "Medium",
    High = "High",
}

export class QuickAction implements IQuickAction {
    id!: string | undefined;
    name!: string | undefined;
    url!: string | undefined;
    type!: ActionType;
    confirm!: boolean | undefined;

    constructor(data?: IQuickAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.type = _data["type"];
            this.confirm = _data["confirm"];
        }
    }

    static fromJS(data: any): QuickAction {
        data = typeof data === 'object' ? data : {};
        let result = new QuickAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["type"] = this.type;
        data["confirm"] = this.confirm;
        return data;
    }
}

export interface IQuickAction {
    id: string | undefined;
    name: string | undefined;
    url: string | undefined;
    type: ActionType;
    confirm: boolean | undefined;
}

export class Recommendation extends MessageDetails implements IRecommendation {
    name!: string | undefined;
    state!: RecommendationState;
    type!: RecommendationType;
    options!: RecommendationOption[] | undefined;
    actions!: RecommendationAction[] | undefined;
    text!: string | undefined;
    url!: string | undefined;

    constructor(data?: IRecommendation) {
        super(data);
        this._discriminator = "Recommendation";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.state = _data["state"];
            this.type = _data["type"];
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(RecommendationOption.fromJS(item));
            }
            if (Array.isArray(_data["actions"])) {
                this.actions = [] as any;
                for (let item of _data["actions"])
                    this.actions!.push(RecommendationAction.fromJS(item));
            }
            this.text = _data["text"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): Recommendation {
        data = typeof data === 'object' ? data : {};
        let result = new Recommendation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["state"] = this.state;
        data["type"] = this.type;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.actions)) {
            data["actions"] = [];
            for (let item of this.actions)
                data["actions"].push(item ? item.toJSON() : undefined as any);
        }
        data["text"] = this.text;
        data["url"] = this.url;
        super.toJSON(data);
        return data;
    }
}

export interface IRecommendation extends IMessageDetails {
    name: string | undefined;
    state: RecommendationState;
    type: RecommendationType;
    options: RecommendationOption[] | undefined;
    actions: RecommendationAction[] | undefined;
    text: string | undefined;
    url: string | undefined;
}

export class RecommendationAction implements IRecommendationAction {
    id!: string | undefined;
    name!: string | undefined;
    type!: ActionType;

    constructor(data?: IRecommendationAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RecommendationAction {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        return data;
    }
}

export interface IRecommendationAction {
    id: string | undefined;
    name: string | undefined;
    type: ActionType;
}

export class RecommendationOption implements IRecommendationOption {
    id!: string | undefined;
    label!: string | undefined;
    description!: string | undefined;
    value!: string | undefined;

    constructor(data?: IRecommendationOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.label = _data["label"];
            this.description = _data["description"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RecommendationOption {
        data = typeof data === 'object' ? data : {};
        let result = new RecommendationOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["label"] = this.label;
        data["description"] = this.description;
        data["value"] = this.value;
        return data;
    }
}

export interface IRecommendationOption {
    id: string | undefined;
    label: string | undefined;
    description: string | undefined;
    value: string | undefined;
}

export enum RecommendationState {
    Open = "Open",
    Accepted = "Accepted",
    InProgress = "InProgress",
    Completed = "Completed",
    Rejected = "Rejected",
}

export enum RecommendationType {
    Single = "Single",
    Multiple = "Multiple",
    Confirmation = "Confirmation",
}

export class SimpleMessage extends MessageDetails implements ISimpleMessage {
    text!: string | undefined;

    constructor(data?: ISimpleMessage) {
        super(data);
        this._discriminator = "SimpleMessage";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SimpleMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        super.toJSON(data);
        return data;
    }
}

export interface ISimpleMessage extends IMessageDetails {
    text: string | undefined;
}

export class SystemMessage extends MessageDetails implements ISystemMessage {

    constructor(data?: ISystemMessage) {
        super(data);
        this._discriminator = "SystemMessage";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SystemMessage {
        data = typeof data === 'object' ? data : {};
        let result = new SystemMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISystemMessage extends IMessageDetails {
}

export class UserAction extends MessageDetails implements IUserAction {
    sourceMessageId!: string | undefined;
    optionIds!: string[] | undefined;
    actionId!: string | undefined;
    parameters!: { [key: string]: any; } | undefined;
    createdAt!: Date;
    updatedAt!: Date;
    userId!: string | undefined;

    constructor(data?: IUserAction) {
        super(data);
        this._discriminator = "UserAction";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sourceMessageId = _data["sourceMessageId"];
            if (Array.isArray(_data["optionIds"])) {
                this.optionIds = [] as any;
                for (let item of _data["optionIds"])
                    this.optionIds!.push(item);
            }
            this.actionId = _data["actionId"];
            if (_data["parameters"]) {
                this.parameters = {} as any;
                for (let key in _data["parameters"]) {
                    if (_data["parameters"].hasOwnProperty(key))
                        (this.parameters as any)![key] = _data["parameters"][key];
                }
            }
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined as any;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserAction {
        data = typeof data === 'object' ? data : {};
        let result = new UserAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceMessageId"] = this.sourceMessageId;
        if (Array.isArray(this.optionIds)) {
            data["optionIds"] = [];
            for (let item of this.optionIds)
                data["optionIds"].push(item);
        }
        data["actionId"] = this.actionId;
        if (this.parameters) {
            data["parameters"] = {};
            for (let key in this.parameters) {
                if (this.parameters.hasOwnProperty(key))
                    (data["parameters"] as any)[key] = (this.parameters as any)[key];
            }
        }
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined as any;
        data["userId"] = this.userId;
        super.toJSON(data);
        return data;
    }
}

export interface IUserAction extends IMessageDetails {
    sourceMessageId: string | undefined;
    optionIds: string[] | undefined;
    actionId: string | undefined;
    parameters: { [key: string]: any; } | undefined;
    createdAt: Date;
    updatedAt: Date;
    userId: string | undefined;
}